import { useMemo } from "react";

import { cn } from "@/lib/utils";
import { useTheme } from "@/theme/theme-provider";
import { getUiBranding } from "@/theme/ui-branding";

type BrandLogoVariant = "horizontal" | "mark";

type BrandLogoProps = {
  variant?: BrandLogoVariant;
  className?: string;
};

const getResolvedTheme = (theme: "dark" | "light" | "system") => {
  if (typeof window === "undefined") {
    return "light" as const;
  }

  if (theme === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? ("dark" as const) : ("light" as const);
  }

  return theme;
};

export const BrandLogo = ({ variant = "horizontal", className }: BrandLogoProps) => {
  const { theme } = useTheme();
  const branding = getUiBranding();
  const resolvedTheme = getResolvedTheme(theme);
  const { src, altText } = useMemo(() => {
  

    const logoSet = variant === "mark" ? branding.logo?.mark : branding.logo?.horizontal;
    const logoVariant = resolvedTheme === "dark" ? logoSet?.dark : logoSet?.light;

    return {
      src: logoVariant?.src,
      altText: logoVariant?.altText ?? "Brand logo",
    };
  }, [branding, resolvedTheme, variant]);

  if (!src) {
    return null;
  }


  return <img alt={altText} className={cn("h-8", className)} src={src} />;
};

